export default "__VITE_ASSET__khBlJYVX__"